<script setup>
import { ref } from "vue";
import { apiUrl, setPassword } from "@/utils/auth";

const typed = ref("");
const error = ref("");
const checking = ref(false);

const logIn = async () => {
  if (!typed.value || checking.value) return;
  checking.value = true;
  error.value = "";
  try {
    const response = await fetch(apiUrl("login"), {
      method: "POST",
      headers: { Authorization: `Bearer ${typed.value}` },
    });
    if (response.ok) {
      setPassword(typed.value);
    } else if (response.status === 429) {
      error.value = "Too many wrong passwords. Try again in 15 minutes.";
    } else {
      error.value = "That password isn't right.";
    }
  } catch {
    error.value = "The stats server couldn't be reached. Try again.";
  }
  checking.value = false;
};
</script>

<template>
  <section class="flex min-h-[70vh] items-center justify-center px-4 py-10">
    <form class="card w-full max-w-sm p-6" @submit.prevent="logIn">
      <h2 class="section-title mb-1">Log in</h2>
      <p class="card-note mb-5">
        Enter the stats password to see how MakeMeA is being used.
      </p>
      <label for="password" class="mb-1.5 block text-sm font-semibold"
        >Password</label
      >
      <input
        id="password"
        v-model="typed"
        type="password"
        autocomplete="current-password"
        class="field mb-3"
        autofocus
      />
      <p
        v-if="error"
        class="mb-3 text-sm text-down dark:text-down-dark"
        role="alert"
      >
        {{ error }}
      </p>
      <button
        type="submit"
        class="btn-primary w-full"
        :disabled="checking || !typed"
      >
        {{ checking ? "Checking…" : "Log in" }}
      </button>
    </form>
  </section>
</template>
